import React, { FC } from 'react';
import ChipWithTooltip from '@components/ChipWithTooltip';
import useChangeReference from '@components/EntityDrawers/components/ReferencesInputsGroup/hooks/useChangeReference';
import { CommonKeys } from '@components/EntityDrawers/constants/keys';
import useQnousRefOptions from '@components/EntityDrawers/hooks/useQnousRefOptions';
import ListItemWithInfo from '@components/Inputs/Autocomplete/items/ListItemWithInfo';
import ControlledAutocomplete from '@components/Inputs/controllers/ControlledAutocomplete';
import { MAX_VISIBLE_CHIP_SYMBOLS } from '@constants/entities/ui';
import { useProject } from '@context/Project';
import useReferenceMaps from '@hooks/useReferenceMaps';
import useUser from '@hooks/useUser';

const QnousInput: FC = () => {
  const { viewOnly } = useProject();

  const [{ isQmsUser }] = useUser();

  const [{ qnousOptions }, isRefsLoading] = useQnousRefOptions();
  const [{ qnousMap }] = useReferenceMaps();

  const { handleChangeReference, isChangingReference } = useChangeReference();

  if (!isQmsUser) return null;

  return (
    <ControlledAutocomplete
      name={CommonKeys.QnousRef}
      label="Qnous reference"
      placeholder="Select reference"
      options={qnousOptions}
      loading={isRefsLoading}
      multiple
      required
      readOnly={viewOnly}
      itemComponent={ListItemWithInfo}
      onChange={handleChangeReference(CommonKeys.QnousRef)}
      isLoading={isChangingReference || isRefsLoading}
      renderTags={(value, getTagProps) => {
        return value.map(({ value, label }, index) => (
          <ChipWithTooltip
            key={value}
            label={label || qnousMap.get(value)}
            tooltip={{
              disableHoverListener: label.length < MAX_VISIBLE_CHIP_SYMBOLS,
            }}
            chip={getTagProps({ index })}
          />
        ));
      }}
    />
  );
};

export default QnousInput;
